/**
 * PlayerStateSection — local player's race progress (status, checkpoint,
 * lap, place, finish time).
 */

import React from 'react';
import type { GmEventState } from '../../../../services/GmEventService';
import { Section, Row, statusColor } from '../RaceDebugPrimitives';

const COLOR = '#2ecc71';

export const PlayerStateSection: React.FC<{
  gmState: GmEventState;
  /** Local player's schema gmLevel (null = schema not readable yet). */
  gmLevel?: number | null;
}> = ({ gmState, gmLevel = null }) => (
  <Section title="Local Player" color={COLOR}>
    {/* GM detection first — Start Race + lobby admin actions gate on
        gmLevel >= 5, so this answers "why is there no Start button" even
        when not in a race. */}
    <Row label="gm level" value={gmLevel === null ? '—' : String(gmLevel)} />
    <Row label="gm detected"
         value={gmLevel !== null && gmLevel >= 5 ? 'YES (can start races)' : 'no'}
         valueColor={gmLevel !== null && gmLevel >= 5 ? '#2ecc71' : '#e74c3c'} />
    {gmState.racePlayerState ? (
      <>
        <Row label="status" value={gmState.racePlayerState.status}
             valueColor={statusColor(gmState.racePlayerState.status)} />
        <Row label="checkpoint"
             value={`${gmState.racePlayerState.checkpointIndex + 1}/${gmState.racePlayerState.totalCheckpoints}`} />
        <Row label="lap" value={String(gmState.racePlayerState.lap)} />
        <Row label="place" value={gmState.racePlayerState.place
          ? `#${gmState.racePlayerState.place}`
          : '—'} />
        <Row label="finish" value={gmState.racePlayerState.finishTimeMs
          ? `${(gmState.racePlayerState.finishTimeMs / 1000).toFixed(2)}s`
          : '—'} />
      </>
    ) : (
      <Row label="status" value="not in race" valueColor="#666" />
    )}
  </Section>
);
